<script>
import {defineComponent} from 'vue';
import appConfig from "../../../app.config.json";
import PageHeader from "@/components/page-header.vue";
import Layout from "@/layouts/main.vue";
import ContainerReports from "@/views/report/container-reports.vue";

export default defineComponent({
  name: "ContainerReport",
  page: {
    title: 'Mensajes',
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    PageHeader,
    Layout,
    ContainerReports
  },
  data: () => ({
    title: '',
    items: [
      {
        text: "Reportes",
        href: "/",
      },
      {
        text: "Generar Reportes",
        active: true,
      },
    ]
  }),
});
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <ContainerReports/>

  </Layout>
</template>
